import { Box } from "@chakra-ui/react";
import { Link } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { LinkProps } from "next/link";
import type { FC, ReactNode } from "react";

interface NotAllowedPageProps {
  title: ReactNode;
  link?: {
    href: LinkProps["href"];
    content: ReactNode;
  };
}

const NotAllowedPage: FC<NotAllowedPageProps> = ({ title, link }) => {
  return (
    <Box mt="8" textAlign="center">
      <h2>{title}</h2>
      {link && (
        <Link href={link.href} fontWeight="bold">
          {link.content}
        </Link>
      )}
    </Box>
  );
};

export default observer(NotAllowedPage);
